export default {
  data() {
    return {}
  },
  computed: {},
  methods: {
    convertRemToPixels(rem) {
      return (
        rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
      )
    },
    scrollToElement(querySelector, noRem) {
      let el = document.querySelector(querySelector)
      let rect = el.getBoundingClientRect()
      const navbarHeight = document.querySelector('.navbar').clientHeight
      let remOffset = noRem ? 0 : 1
      window.scrollTo({
        top:
          rect.top +
          window.pageYOffset -
          navbarHeight -
          this.convertRemToPixels(remOffset),
        behavior: 'smooth',
        left: rect.left
      })
    }
  },
  mounted() {}
}
